import styled from "styled-components"
import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { OkrKeyResult } from "server/models"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    UserIcon,
    Button,
} from "client/components"

import KeyResultEdit from "client/pages/okr/keyResult/edit"


const ConfirmDescriptionStyled = styled(ConfirmDescription)`
    padding-right: 12px;
    color: ${(props) => props.theme.defaultTextColor};
`
const ListWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
const Title = styled.div`
    margin: 12px 0;
    font-size: 16px;
    font-weight: 600;
    font-family: ${(props) => props.theme.openSans};
`
const Description = styled.div`
    margin-bottom: 20px;
    color: ${(props) => props.theme.sessionConfirmDeadlineDescription};
`
const KeyResultWrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 6px;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.sessionConfirmDeadlineKeyResultBorder};

    &:last-child {
        border-bottom: none;
    }
`
const KeyResultDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`
const OwnerWrapper = styled.div`
    display: flex;
    flex-direction: row;

    & > div {
        margin-right: 5px;
    }
`


interface ConfirmDeadlineProps {
    keyResultsSoftConflict: OkrKeyResult[]
    keyResultsHardConflict: OkrKeyResult[]
    onConfirm: () => void
    onCancel: () => void
}

const ConfirmDeadline = ({
    keyResultsSoftConflict,
    keyResultsHardConflict,
    onConfirm,
    onCancel,
}: ConfirmDeadlineProps) => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    return (
        <ConfirmWrapper show onClose={onCancel}>
            <Confirm maxWidth={800}>
                <ConfirmTitle>{lang.conflictsWithUpdate}</ConfirmTitle>
                <ConfirmDescriptionStyled>
                    {
                        keyResultsSoftConflict.length > 0 && (
                            <ListWrapper>
                                <Title>{lang.conflictsWithSoftDeadline}</Title>
                                <Description>{lang.conflictsWithSoftDeadlineDescription}</Description>
                                {
                                    keyResultsSoftConflict.map((keyResult) => (
                                        <KeyResultWrapper key={keyResult.id}>
                                            <KeyResultDescriptionWrapper>
                                                <div>{keyResult.title}</div>
                                                <OwnerWrapper>
                                                    {
                                                        keyResult.owners.map((row) => {
                                                            const user = userList[row.userId]
                                                            return (
                                                                <UserIcon
                                                                    key={row.userId}
                                                                    user={user}
                                                                    size="sm"
                                                                    showName={false}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </OwnerWrapper>
                                            </KeyResultDescriptionWrapper>
                                            <Button onClick={() => dispatch(addModal({
                                                key: "editKeyResult",
                                                content: <KeyResultEdit
                                                    sessionId={keyResult.sessionId}
                                                    objectiveId={keyResult.objectiveId}
                                                    keyResultId={keyResult.id}
                                                />,
                                            }))}
                                            >
                                                {lang.edit}
                                            </Button>
                                        </KeyResultWrapper>
                                    ))
                                }
                            </ListWrapper>
                        )
                    }
                    {
                        keyResultsHardConflict.length > 0 && (
                            <ListWrapper>
                                <Title>{lang.conflictsWithHardDeadline}</Title>
                                <Description>{lang.conflictsWithHardDeadlineDescription}</Description>
                                {
                                    keyResultsHardConflict.map((keyResult) => (
                                        <KeyResultWrapper key={keyResult.id}>
                                            <KeyResultDescriptionWrapper>
                                                <div>{keyResult.title}</div>
                                                <OwnerWrapper>
                                                    {
                                                        keyResult.owners.map((row) => {
                                                            const user = userList[row.userId]
                                                            return (
                                                                <UserIcon
                                                                    key={row.userId}
                                                                    user={user}
                                                                    size="sm"
                                                                    showName={false}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </OwnerWrapper>
                                            </KeyResultDescriptionWrapper>
                                            <Button onClick={() => dispatch(addModal({
                                                key: "editKeyResult",
                                                content: <KeyResultEdit
                                                    sessionId={keyResult.sessionId}
                                                    objectiveId={keyResult.objectiveId}
                                                    keyResultId={keyResult.id}
                                                />,
                                            }))}
                                            >
                                                {lang.edit}
                                            </Button>
                                        </KeyResultWrapper>
                                    ))
                                }
                            </ListWrapper>
                        )
                    }
                </ConfirmDescriptionStyled>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button row variant="danger" onClick={onConfirm}>{lang.ignoreAndUpdate}</Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeadline
